module.exports = __webpack_public_path__ + "img/header-engagementRings025Carat@2x.6a408ad.webp";